import React from 'react';
import { maxPointsFromIndicators } from '../../utils/score';
import { IconClipboard } from '../../components/dashboardIcons';

const fmt = (n) => (Math.round(n * 100) / 100).toFixed(2);

// Renders one element's indicator breakdown from a get_scorecard response.
// (Improvement guidance is shown separately in the "How to improve" list.)
const IndicatorTable = ({ data }) => {
  const indicators = data?.indicators || [];
  const resultMap = Object.fromEntries((data?.results || []).map((r) => [r.id, r]));
  const maxPoints = maxPointsFromIndicators(indicators);
  let lastSection = null;

  if (indicators.length === 0) {
    return (
      <div className="cd-empty compact">
        <span className="ic"><IconClipboard /></span>
        <h3>Nothing calculated yet</h3>
        <p>Upload a data sheet for this element to see its scorecard breakdown.</p>
      </div>
    );
  }

  return (
    <div className="cd-itable">
      <table className="cd-table">
        <thead>
          <tr>
            <th>Indicator</th>
            <th>Target</th>
            <th>Actual</th>
            <th>Points</th>
          </tr>
        </thead>
        <tbody>
          {indicators.map((ind) => {
            const showHeader = ind.section && ind.section !== lastSection;
            lastSection = ind.section;
            const r = resultMap[ind.id];
            const actual = r?.actual ?? null;
            const pts = r?.points ?? 0;
            const failed = r?.sub_minimum_met === false;
            return (
              <React.Fragment key={ind.id}>
                {showHeader && (
                  <tr className="section"><td colSpan="4">{ind.section}</td></tr>
                )}
                <tr className={failed ? 'fail' : undefined}>
                  <td>
                    {failed && <span className="cd-fail-mark" aria-hidden="true">⚠</span>}
                    {ind.label}
                    {failed && <span className="cd-visually-hidden"> — sub-minimum not met</span>}
                  </td>
                  <td>{ind.targetLabel ?? `${ind.target}%`}</td>
                  <td>{actual !== null ? `${fmt(actual)}%` : '—'}</td>
                  <td>{fmt(pts)}</td>
                </tr>
              </React.Fragment>
            );
          })}
          <tr className="total">
            <td colSpan="3">Total</td>
            <td>{fmt(data?.total_points ?? 0)} / {maxPoints || '—'}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default IndicatorTable;
